import { combineReducers } from 'redux'

import {
  CHANGE_NABVAR,
  SCROLL_TO_HEADER,
  SCROLL_TO_ABOUT,
  SCROLL_TO_SERVICES,
  SCROLL_TO_PROJECTS,
  SCROLL_TO_PARTNERS,
  SCROLL_TO_GAMES,
  SCROLL_TO_CONTACT,
  SCROLL_TO
} from './actions'

const initialState = {
	haveHeader: true,
  scrollToAbout: null,
  scrollToServices: null,
  scrollToProjects: null,
  scrollToPartners: null,
  scrollToGames: null,
  scrollToContact: null,
  scrollTo: ""
}

const ChangeNavbar = (state=initialState, action) => {
  switch (action.type) {
 	  	case CHANGE_NABVAR:
 			  return {...state, haveHeader: action.haveHeader};

		default:
	   		return state;
	}
}

const ScrollToHeader = (state=initialState, action) => {
  switch (action.type) {
 	  	case SCROLL_TO_HEADER:
 			  return {...state, scrollToHeader: action.scrollToHeader};
		default:
	   		return state;
	}
}

const ScrollToAbout = (state=initialState, action) => {
  switch (action.type) {
 	  	case SCROLL_TO_ABOUT:
 			  return {...state, scrollToAbout: action.scrollToAbout};
		default:
	   		return state;
	}
}

const ScrollToServices = (state=initialState, action) => {
  switch (action.type) {
      case SCROLL_TO_SERVICES:
 			  return {...state, scrollToServices: action.scrollToServices};
		default:
	   		return state;
	}
}

const ScrollToProjects = (state=initialState, action) => {
  switch (action.type) {
      case SCROLL_TO_PROJECTS:
 			  return {...state, scrollToProjects: action.scrollToProjects};
		default:
	   		return state;
	}
}

const ScrollToPartners = (state=initialState, action) => {
  switch (action.type) {
      case SCROLL_TO_PARTNERS:
 			  return {...state, scrollToPartners: action.scrollToPartners};
		default:
	   		return state;
	}
}

const ScrollToGames = (state=initialState, action) => {
  switch (action.type) {
      case SCROLL_TO_GAMES:
 			  return {...state, scrollToGames: action.scrollToGames};
		default:
	   		return state;
	}
}

const ScrollToContact = (state=initialState, action) => {
  switch (action.type) {
      case SCROLL_TO_CONTACT:
 			  return {...state, scrollToContact: action.scrollToContact};
		default:
	   		return state;
	}
}

const ScrollTo = (state=initialState, action) => {
  switch (action.type) {
      case SCROLL_TO:
 			  return {...state, scrollTo: action.scrollTo};
		default:
	   		return state;
	}
}

const AppReducers = combineReducers({
	ChangeNavbar,
  ScrollToHeader,
  ScrollToAbout,
  ScrollToServices,
  ScrollToProjects,
  ScrollToPartners,
  ScrollToGames,
  ScrollToContact,
  ScrollTo
})

export default AppReducers
